import { render, staticRenderFns } from "./producer_edit_cider_page.vue?vue&type=template&id=8cad3578&scoped=true"
import script from "./producer_edit_cider_page.vue?vue&type=script&lang=js"
export * from "./producer_edit_cider_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cad3578",
  null
  
)

export default component.exports